var map = {
	"./birthday1.png": 154,
	"./birthday2.png": 155,
	"./birthday3.png": 156,
	"./blue-back.png": 157,
	"./cabbage-broccoli.png": 158,
	"./candy.png": 159,
	"./carbs1.png": 160,
	"./carbs2.png": 161,
	"./carbs3.png": 162,
	"./carbs4.png": 163,
	"./carbs5.png": 164,
	"./carbs6.png": 165,
	"./demo1.png": 166,
	"./demo2.png": 167,
	"./demo3.png": 168,
	"./demo4.png": 169,
	"./demo5.png": 170,
	"./demo6.png": 171,
	"./fats1.png": 172,
	"./fats2.png": 173,
	"./fats3.png": 174,
	"./fats4.png": 175,
	"./fats5.png": 176,
	"./fats6.png": 177,
	"./fruits1.png": 178,
	"./fruits2.png": 179,
	"./fruits3.png": 180,
	"./fruits4.png": 181,
	"./fruits5.png": 182,
	"./fruits6.png": 183,
	"./grandma1.png": 184,
	"./grandma2.png": 185,
	"./grandma3.png": 186,
	"./green-back.png": 187,
	"./joker1.png": 188,
	"./joker2.png": 189,
	"./joker3.png": 190,
	"./onion-garlic.png": 191,
	"./orange-back.png": 192,
	"./pink-back.png": 193,
	"./proteins1.png": 194,
	"./proteins2.png": 195,
	"./proteins3.png": 196,
	"./proteins4.png": 197,
	"./proteins5.png": 198,
	"./proteins6.png": 199,
	"./red-back.png": 200,
	"./stop1.png": 201,
	"./stop2.png": 202,
	"./stop3.png": 203,
	"./surprise-meal1.png": 204,
	"./surprise-meal2.png": 205,
	"./surprise-meal3.png": 206,
	"./switch-friend1.png": 207,
	"./switch-friend2.png": 208,
	"./switch-friend3.png": 209,
	"./switch-stack1.png": 210,
	"./switch-stack2.png": 211,
	"./switch-stack3.png": 212,
	"./trip1.png": 213,
	"./trip2.png": 214,
	"./trip3.png": 215,
	"./vegetables1.png": 216,
	"./vegetables2.png": 217,
	"./vegetables3.png": 218,
	"./vegetables4.png": 219,
	"./virus1.png": 220,
	"./virus2.png": 221,
	"./virus3.png": 222,
	"./water1.png": 223,
	"./water2.png": 224,
	"./water3.png": 225,
	"./white-back.png": 226,
	"./yellow-back.png": 227
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47;